import { type ReactNode, useEffect } from "react";
import { useAuthStore } from "@/store/auth.store";
import { connectSocket, disconnectSocket } from "@/sockets/socket";

/**
 * Owns the single shared Socket.IO connection lifecycle: connects once an
 * admin is authenticated, disconnects on sign-out. No page/component opens
 * its own connection (see admin build rules, section 17).
 */
export function SocketProvider({ children }: { children: ReactNode }) {
  const isAuthenticated = useAuthStore((s) => !!s.accessToken);

  useEffect(() => {
    if (isAuthenticated) {
      connectSocket();
    } else {
      disconnectSocket();
    }
    return () => {
      if (!isAuthenticated) disconnectSocket();
    };
  }, [isAuthenticated]);

  return <>{children}</>;
}
